export enum RequestStatus {
  Idle = 1,
  Pending,
  Fulfilled,
  Rejected
}
export interface RequestInfo {
  status: RequestStatus;
  error: string | null;
}